import OrderDetailContent, { OrderDetailProps } from '@views/OrderDetail/OrderDetailContent';
import React from 'react';

const OrderDetail = (props: OrderDetailProps) => (
  <div className="tw-px-4">
    <div className="tw-max-w-4xl tw-mx-auto">
      <OrderDetailContent {...props} trackOrderDetail />
    </div>
  </div>
);

export default OrderDetail;
